import React from 'react';
import { BaseRow } from '../shared/BaseRow';
import { MentionText } from '../shared';
import { AuthorName, DateText, CommentText, CommentHeader, commentFilesContainerStyle, commentFileThumbStyle, } from './styles';
import dayjs from 'dayjs';
var CommentRow = function (_a) {
    var _b;
    var comment = _a.comment, _c = _a.isClient, isClient = _c === void 0 ? false : _c, _d = _a.validMentions, validMentions = _d === void 0 ? [] : _d;
    var formattedDate = dayjs(comment.created_at).fromNow();
    var authorLabel = isClient ? 'Cliente' : 'Admin';
    var authorName = ((_b = comment.created_by) === null || _b === void 0 ? void 0 : _b.name) || 'Usuario';
    var leftBarColor = isClient ? '#E8F2FF' : '#6f98c9';
    var header = (React.createElement(CommentHeader, null,
        React.createElement(AuthorName, null,
            authorLabel,
            " - ",
            authorName),
        React.createElement(DateText, null, formattedDate)));
    return (React.createElement(BaseRow, { leftBarColor: leftBarColor, leftBarWidth: 4, leftBarBorderRadius: 24, header: header, content: React.createElement(CommentText, null,
            React.createElement(MentionText, { text: comment.content, validMentions: validMentions })), files: comment.files, filesContainerStyle: commentFilesContainerStyle, fileThumbStyle: commentFileThumbStyle, containerStyle: {
            display: 'grid',
            gridTemplateColumns: '6px 1fr',
            gap: '12px',
            marginBottom: 0,
            padding: '10px 12px',
            borderRadius: '10px',
        }, contentStyle: { gap: '6px' } }));
};
export default CommentRow;
